import ReactDOM from 'react-dom';
import React from 'react';
import TopMenuAskWavesBtn from './top-menu-ask-waves-btn';

export const initMobileMenuAksWaves = () => {
    const $placeholder = document.getElementById('m-ask-waves-top-menu-placeholder');
    if(!$placeholder) return;

    ReactDOM.render(
        <TopMenuAskWavesBtn classes="ask-waves__mobile" />,
        $placeholder
    );
};

export const initTabletMenuAksWaves = () => {
    const $placeholder = document.getElementById('t-ask-waves-top-menu-placeholder');
    if(!$placeholder) return;

    ReactDOM.render(
        <TopMenuAskWavesBtn classes="ask-waves__tablet"  />,
        $placeholder
    );
};